import * as React from 'react';
import {FormEvent} from 'react';
import Button from "@components/common/button/Button";
import {IFamilyMember} from '@app-types/websocket/family.types';
import spawnHandoverDays from '@helpers/spawnHandoverDays';
import TranslateNew from "@translate/TranslateNew";
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {GuideStyles} from '../guide.styles';
import ProgressBar from "@components/common/progressBar/progressBar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import LocationSelect from './LocationSelect';
import Select from "@components/common/select/Select";
import {MenuItem} from "@material-ui/core";
import clsx from "clsx";
import cordovaContext from "../../../cordovaContext";

const tn: TranslateNew = TranslateNew.getInstance();

const timeOptions = [
    {value: '06:00', label: '06:00'},
    {value: '06:30', label: '06:30'},
    {value: '07:00', label: '07:00'},
    {value: '07:30', label: '07:30'},
    {value: '08:00', label: '08:00'},
    {value: '08:30', label: '08:30'},
    {value: '09:00', label: '09:00'},
    {value: '09:30', label: '09:30'},
    {value: '10:00', label: '10:00'},
    {value: '10:30', label: '10:30'},
    {value: '11:00', label: '11:00'},
    {value: '11:30', label: '11:30'},
    {value: '12:00', label: '12:00'},
    {value: '12:30', label: '12:30'},
    {value: '13:00', label: '13:00'},
    {value: '13:30', label: '13:30'},
    {value: '14:00', label: '14:00'},
    {value: '14:30', label: '14:30'},
    {value: '15:00', label: '15:00'},
    {value: '15:30', label: '15:30'},
    {value: '16:00', label: '16:00'},
    {value: '16:30', label: '16:30'},
    {value: '17:00', label: '17:00'},
    {value: '17:30', label: '17:30'},
    {value: '18:00', label: '18:00'},
    {value: '18:30', label: '18:30'},
    {value: '19:00', label: '19:00'},
    {value: '19:30', label: '19:30'},
    {value: '20:00', label: '20:00'},
    {value: '20:30', label: '20:30'},
    {value: '21:00', label: '21:00'},
];

interface IOption {
    value: string;
    label: string;
    isDisabled?: boolean;
}

export interface IHandoverDay {
    id: number;
    hour: number;
    minutes: number;
    atSchool: boolean;
    parent: string;
    location: string;
    dayName: string;
}

interface IStepHandoverProps extends WithStyles<typeof GuideStyles> {
    setHandoverDays: (days: any[]) => void;
    toggleSnackBar: (state: boolean) => void;
    setStepErrorType: (type: string) => void;
    startDate: Date;
    secondParent: IFamilyMember;
    firstParent: IFamilyMember;
    schoolAge: number;
    days: boolean[];
    step: number;
    progress?: number | undefined;
    setStep: (step: number) => void;
    goBack: () => void;
    style?:React.CSSProperties;
}

interface IStepHandoverState {
    timeOptions: IOption[];
    locationOptions: IOption[];
    customLocations: string[];
    handoverDaysToShow: IHandoverDay[];
    hasDoneFirstLocationChange: boolean;
    hasDoneFirstTimeChange: boolean;
    formValues: {
        handoverDays: IHandoverDay[];
    };
    formErrors: {
        handoverDays?: string | undefined;
    };
}


class StepHandover extends React.Component<IStepHandoverProps, IStepHandoverState> {

    constructor(props: IStepHandoverProps) {
        super(props);

        const {
            firstParent: {firstName: parentAName},
            secondParent: {firstName: parentBName}
        } = props;

        const schoolLabel = tn.lang.labelSchoolStartEnd(undefined, props.schoolAge);

        const locationOptions = [
            {value: 'Unspecified', label: tn.lang.labelUnspecified},
            {value: 'School', label: schoolLabel},
            {value: tn.lang.labelParentsHome(parentAName), label: tn.lang.labelParentsHome(parentAName)},
            {value: tn.lang.labelParentsHome(parentBName), label: tn.lang.labelParentsHome(parentBName)},
        ];

        const handoverDays = spawnHandoverDays(props.days);

        let handoverDaysShow: IHandoverDay[] = [];
        let i: number = 1;
        while (i <= handoverDays.length) {
            if (handoverDays[i - 1].parent !== handoverDays[(i % handoverDays.length)].parent) {
                handoverDaysShow.push(handoverDays[(i % handoverDays.length)]);
            }
            i++;
        }
        handoverDaysShow = handoverDaysShow.sort((a: any, b: any) => a.parent.localeCompare(b.parent));

        this.state = {
            formValues: {
                handoverDays,
            },
            formErrors: {
                handoverDays: undefined,
            },
            handoverDaysToShow: handoverDaysShow,
            hasDoneFirstLocationChange: false,
            hasDoneFirstTimeChange: false,
            timeOptions: [...timeOptions, {value: 'na', label: schoolLabel, isDisabled: true}],
            locationOptions,
            customLocations: [],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLocChange = this.handleLocChange.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.validateHandoverDays = this.validateHandoverDays.bind(this);
        this.resetToDefault = this.resetToDefault.bind(this);
    }

    public componentDidUpdate = (nextProps: any) => {
        if (nextProps.days && (nextProps.days !== this.props.days) && nextProps.startDate && nextProps.days.length) {

            const handoverDays: IHandoverDay[] = spawnHandoverDays(nextProps.days);

            let handoverDaysShow: IHandoverDay[] = [];
            let i: number = 1;
            while (i <= handoverDays.length) {
                if (handoverDays[i - 1].parent !== handoverDays[(i % handoverDays.length)].parent) {
                    handoverDaysShow.push(handoverDays[(i % handoverDays.length)]);
                }
                i++;
            }
            handoverDaysShow = handoverDaysShow.sort((a: any, b: any) => a.parent.localeCompare(b.parent));

            this.setState({handoverDaysToShow: handoverDaysShow, formValues: {handoverDays}});

        }
    }


    public render() {
        const {
            formValues,
            formErrors,
            locationOptions,
            customLocations,
        } = this.state;
        const {
            classes: style, step,
            secondParent,
            firstParent,
        } = this.props;
        const isCordovaApp = this.context;


        return (
            <div className={style.container}  style={this.props.style}>
                <div className={clsx([style.topBar, style.topBarWithBackButton])}>
                    {this.props.progress && (<ProgressBar value={this.props.progress + step}/>)}
                    <Button variant="text" onClick={this.resetToDefault} className={style.backButton}>
                        <ArrowBackIcon fontSize="small"/>
                        <span style={{flex: 1}}>{tn.lang.back}</span>
                    </Button>
                </div>
                <div className={style.topContent}>
                    <Typography variant="h2">{tn.lang.newCalendarHandoverTitle}</Typography>
                </div>
                <form className={style.form} onSubmit={this.handleSubmit}>
                    <div className={style.formMiddleContent}>
                        {this.state.handoverDaysToShow && this.state.handoverDaysToShow.length
                            && this.state.handoverDaysToShow.map((day: IHandoverDay, index: number) => {
                                const {id, parent, atSchool, dayName, location, hour, minutes} = day;
                                const parentName = parent === 'ParentA' ? firstParent.firstName : secondParent.firstName;
                                return (
                                    <div className={style.handoverContainer} key={day.parent + index}>
                                        <Typography className={style.label}>
                                            {tn.lang.newCalendarWhereIsHandover(parentName, tn.formatWeekdayName(dayName))}
                                        </Typography>
                                        <div className={style.handoverRow}>
                                            <LocationSelect
                                                id={`handover-location-${day.parent + index}`}
                                                name={`handover-location-${day.parent + index}`}
                                                value={location ? location : "Unspecified"}
                                                onChange={(value: string) => this.handleLocChange(value, id)}
                                                baseOptions={locationOptions}
                                                customLocations={customLocations}
                                                onAddCustomLocation={this.handleAddCustomLocation}
                                                placeholder={tn.lang.labelLocation}
                                                style={{flex: '1 1 0%'}}
                                                native={isCordovaApp}
                                                error={!!(formErrors.handoverDays)}
                                                customLabel={tn.lang.other + '...'}
                                                inputPlaceholder={tn.lang.labelLocation}
                                            />
                                            <Select
                                                style={atSchool
                                                    ? {
                                                        display: 'none',
                                                    }
                                                    : {
                                                        flex: '0 0 90px',
                                                        width: '90px',
                                                        maxWidth: '90px',
                                                        minWidth: '0px',
                                                    }}
                                                id={`handover-time-${day.parent + index}`}
                                                name={`handover-time-${day.parent + index}`}
                                                disabled={atSchool}
                                                native={isCordovaApp} 
                                                onChange={(event: any) =>
                                                    this.handleTimeChange(event.target.value, id)}
                                                value={atSchool ? "na" : (
                                                    (hour < 10 ? ("0" + hour) : hour) + ":"
                                                    + (minutes < 10 ? ("0" + minutes) : minutes)
                                                )}
                                                placeholder={tn.lang.labelLocation}
                                                error={!!(formErrors.handoverDays)}
                                            >
                                                {this.state.timeOptions.map((opt: any) => {
                                                    const Element = isCordovaApp ? 'option' : MenuItem;
                                                    return (<Element
                                                        value={opt.value}
                                                        key={opt.value}
                                                        disabled={opt.isDisabled}
                                                    >
                                                        {opt.label}
                                                    </Element>);
                                                })}
                                            </Select>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        {formErrors.handoverDays &&
                            <Typography className={style.errorMessage}>{formErrors.handoverDays}</Typography>}
                    </div>
                    <div className={style.formBottomContent}>
                        <Button
                            type="submit"
                            variant='contained'
                            color='primary'
                            size="large"
                            fullWidth={true}
                        >
                            {tn.lang.continue}
                        </Button>
                    </div>
                </form>
            </div>);
    }

    private handleAddCustomLocation = (value: string) => {
        this.setState((prevState) => ({
            customLocations: [...prevState.customLocations, value],
        }));
    }

    private handleLocChange = (newLoc: string, id: number) => {
        const handoverDaysToShow = this.state.handoverDaysToShow.slice();

        if (!this.state.hasDoneFirstLocationChange) {
            for (const day of handoverDaysToShow) {
                day.location = newLoc;
                day.atSchool = (newLoc === "School");
            }
            this.setState((prevState) => ({
                handoverDaysToShow,
                hasDoneFirstLocationChange: true,
                formErrors: {
                    ...prevState.formErrors,
                    handoverDays: undefined,
                },
            }));
        } else {
            const objIndex = this.getIndexById(handoverDaysToShow, id);
            handoverDaysToShow[objIndex!].location = newLoc;
            handoverDaysToShow[objIndex!].atSchool = (newLoc === "School");
            this.setState((prevState) => ({
                handoverDaysToShow,
                formErrors: {
                    ...prevState.formErrors,
                    handoverDays: undefined,
                },
            }));
        }
    }

    private handleTimeChange = (newTime: string, id: number) => {
        const handoverDaysToShow = this.state.handoverDaysToShow.slice();

        const objIndex = this.getIndexById(handoverDaysToShow, id);
        const timeSplit: string[] = newTime.split(":");
        const timeHours: number = parseInt(timeSplit[0], 10);
        const timeMinutes: number = parseInt(timeSplit[1], 10);

        if (!this.state.hasDoneFirstTimeChange) {
            for (const day of handoverDaysToShow) {
                if (!day.atSchool) {
                    day.hour = timeHours;
                    day.minutes = timeMinutes;
                }
            }
            this.setState((prevState) => ({
                handoverDaysToShow,
                hasDoneFirstTimeChange: true,
                formErrors: {
                    ...prevState.formErrors,
                    handoverDays: undefined,
                },
            }));
        } else {
            handoverDaysToShow[objIndex!].hour = timeHours;
            handoverDaysToShow[objIndex!].minutes = timeMinutes;
            this.setState((prevState) => ({
                handoverDaysToShow,
                formErrors: {
                    ...prevState.formErrors,
                    handoverDays: undefined,
                },
            }));
        }
    }

    private getIndexById =  (array: IHandoverDay[], id: number) => {
        if (!array || id < 0) return;
        return array.findIndex((obj: IHandoverDay) => obj.id === id);
    };

    private handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const {setHandoverDays, toggleSnackBar, setStepErrorType, setStep} = this.props;
        const {formValues} = this.state;
        const isTemplateValid = this.validateHandoverDays();

        if (isTemplateValid) {
            try {
                setHandoverDays(formValues.handoverDays);
            } catch (error) {
                toggleSnackBar(true);
                setStepErrorType(error);
            }
        }
    }


    private validateHandoverDays = (): boolean => {
        const {formValues, handoverDaysToShow} = this.state;

        const cardWithCorruptedData = handoverDaysToShow
            .find((day: IHandoverDay) => (
                !(
                    (day.atSchool)
                    || (
                        (day.location.length > 1)
                        && (day.hour >= 0 && day.hour < 24)
                        && (day.minutes >= 0 && day.minutes < 60)
                    )
                )
            ));

        if (cardWithCorruptedData) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors,
                    handoverDays: tn.lang.CalendarTemplatesErrorHandover,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors,
                handoverDays: undefined,
            },
        }));
        return true;
    }

    private resetToDefault = () => {
        const {setStep, days} = this.props;
        this.setState(
            {
                formValues: {
                    handoverDays: spawnHandoverDays(days),
                },
                formErrors: {
                    handoverDays: undefined,
                },
            }
        );

        if (this.props.goBack) {
            this.props.goBack();
        } else {
            setStep(4);
        }
    }
}

StepHandover.contextType = cordovaContext;

export default withStyles(GuideStyles)(StepHandover);



// WEBPACK FOOTER //
// ./src/components/guide/steps/stepHandover.component.tsx